export default __webpack_public_path__ + "static/media/finance-topic1.cbfccaf1.png";